<template>
    <svg
      :viewBox="`0 0 ${sizeInPx} ${sizeInPx}`"
      preserveAspectRatio="xMidYMid meet"
      :style="{
        transform: `scale(${scale()})`,
        transition: 'transform 0.5s'
      }"
      >
        <SunShine :id="id">
          <radialGradient
            gradientUnits="userSpaceOnUse"
            :id="props.id"
            :cy="`${shadowP.cy}%`"
            :cx="`${props.slider ? cx(props.slider): shadowP.cx}%`"
            :r="`${props.radiusDynamic ? radius(props.slider) : shadowP.r }%`"
            :fx="`${shadowP.fx === undefined ? props.slider ? cx(props.slider): shadowP.cx : shadowP.fx}%`"
            :fy="`${shadowP.fy === undefined ? shadowP.cy : shadowP.fx}%`"
            :fr="`${shadowP.fr === undefined ? 0 : shadowP.fr}%`"
          >
              <stop v-for="(stop, index) in shadowP.stop" :key="index"
                :class="`${hover || selected || animationSelected ? `stop-${index}` : ''}`"
                :offset="`${stop.offset}%`"
                :stop-color="stop.color"
                :stop-opacity="`${stop.opacity}%`"
              >
            </stop>
            <animate attributeName="r" dur="2000ms" :values="`${selectedShadow()}%;${((props.hover || props.selected) ? shadowP.r * 0.8 : selectedShadow())}%;${selectedShadow()}%`" repeatCount="indefinite" v-if="hover || selected"/>
          </radialGradient>
        </SunShine :size=sizeInPx>
    </svg>
</template>
<script setup lang="ts">
import { Color, type TypeColor, defaultShadow, type ShadowType} from '../../interfaces'
import { SunShine } from '../../atoms'
import { normalizeBetweenRange } from '../../utils'
import { computed } from 'vue'
defineOptions({
  inheritAttrs: false
})
const selectedShadow = () => {
  return props.selected ? shadowP.value.r  * 0.85 : shadowP.value.r
}
const scale = () => {
  const base = ((props.scale + (1 - props.scale) / 2))
  return props.selected ?  base : props.hover  ? base : props.scale
}
export interface PropsSunGradient {
  sizeInPx?: number
  colorEnd?: TypeColor
  slider?: number,
  min?: number,
  max?: number,
  shadow?: ShadowType | (() => ShadowType)
  r?: number
  animationSelected?: boolean
  id?: string
  scale?: number
  radiusDynamic?: boolean
  hover?:boolean
  selected?: boolean
}

const props = withDefaults(defineProps<PropsSunGradient>(), {
  sizeInPx: 480,
  colorEnd: Color.white,
  min: 0,
  max: 100,
  shadow: () => ({
    ...defaultShadow
  }),
  id: 'Radial1',
  animationSelected: false,
  r: defaultShadow.r,
  radiusDynamic: false,
  hover: false,
  selected: false,
  scale: 1
})

const shadowP = computed(() => {
  const output =  typeof props.shadow === 'function' ? props.shadow() : props.shadow
  return output
})

const cx = (value:number,  targetMin:number = 20, targetMax:number = 80):string => {
  let normalize = value === undefined ? shadowP.value.cx : normalizeBetweenRange(value, {min: targetMax, max: targetMin}, {min: props.min, max: props.max})
  return `${normalize}`;
}

const radius = (value?: number) => {
  let output
  const r = shadowP.value.r ? defaultShadow.r : shadowP.value.r
  if (value === undefined) output = r
  if (value && value === 50) output = r
  if (value && value > 50) output = normalizeBetweenRange(+value, {min: r , max: 100 }, {min: (props.max - props.min) / 2, max: props.max})
  if (value && value < 50) output = normalizeBetweenRange(+value, {min: 90 , max: r }, {min: (props.max - props.min) / 2, max: props.max})
  return `${output}`
}
</script>
<style lang="scss" scoped>
@keyframes moveGradient1 {
  0%, 100% {
    stop-opacity: 30%;
    offset: 70%;
  }
  50% {
    stop-opacity: 60%;
    offset: 40%;
  }
}
@keyframes moveGradient2 {
  0%, 100% {
   opacity: 100%;
    offset: 80%;
  }
  50% {
    opacity: 90%;
    offset: 100%;
  }
}
.stop-0 {
  animation: moveGradien1 2s linear infinite;
  offset: 80%;
  transition: offset 0.5s;
}
.stop-1 {
  animation: moveGradien2 2s linear infinite;
}
</style>
